export default __webpack_public_path__ + "img/Poppins-Thin_bd456a3.eot";